import React from 'react';

const GTM_ID = 'GTM-PG465H';

const GTMNoScript = () => {
  return (
    <noscript>
      <iframe
        height="0"
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
        width="0"
      />
    </noscript>
  );
};

const GTMScript = () => {
  const defer = false;

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      ${defer ? 'j.defer=true;' : 'j.async=true;'}
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');
    `,
      }}
    />
  );
};

export const GTM = () => {
  return (
    <>
      <GTMScript />
      <GTMNoScript />
    </>
  );
};
